import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';
import type { ContinuationEventKind } from '../types';

const KIND_STYLES: Record<ContinuationEventKind, { color: string; icon: string }> = {
  spawn: { color: 'text-info', icon: '+' },
  wake: { color: 'text-tower-success', icon: '⏰' },
  model_call: { color: 'text-purpleToken', icon: '🧠' },
  tool_call: { color: 'text-info', icon: '🔧' },
  publish: { color: 'text-success', icon: '📄' },
  fork: { color: 'text-purpleToken', icon: '🔀' },
  merge: { color: 'text-purpleToken', icon: '🔗' },
  sleep: { color: 'text-tower-warning', icon: '💤' },
  kill: { color: 'text-tower-danger', icon: '✕' },
  budget_charge: { color: 'text-tower-muted', icon: '$' },
  human_signal: { color: 'text-warning', icon: '👤' },
  field_recompute: { color: 'text-tower-muted', icon: '🔄' },
  error: { color: 'text-tower-danger', icon: '!' },
};

export function EventLogWidget(_props: WidgetProps) {
  const events = useJournalStore((s) => s.liveEvents);
  const sorted = [...events].sort((a, b) => b.ts.localeCompare(a.ts)).slice(0, 100);

  return (
    <div className="p-2 overflow-y-auto h-full">
      {sorted.length === 0 && <div className="text-tower-muted text-sm p-2">No events yet</div>}
      {sorted.map((evt) => {
        const style = KIND_STYLES[evt.kind] || { color: 'text-tower-muted', icon: '?' };
        const time = new Date(evt.ts).toLocaleTimeString();
        const summary = evt.payload?.summary || evt.payload?.reason || evt.payload?.signalType || evt.kind;
        return (
          <div key={evt.id} className="flex gap-2 py-1 px-1 text-xs border-b border-tower-border/50 animate-fade-in">
            <span className="text-tower-muted font-mono w-16 shrink-0">{time}</span>
            <span className={`${style.color} w-4 text-center`}>{style.icon}</span>
            <span className={`${style.color} font-mono w-20 shrink-0`}>{evt.kind}</span>
            <span className="text-tower-text truncate">{String(summary)}</span>
            {evt.cost && (
              <span className="text-tower-muted font-mono ml-auto shrink-0">${evt.cost.dollars.toFixed(4)}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
